import { render, staticRenderFns } from "./WarnAppError.vue?vue&type=template&id=3bfb52ec"
import script from "./WarnAppError.vue?vue&type=script&lang=ts"
export * from "./WarnAppError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports